export const sortClients = (clients) => {
  return [...clients].sort((a, b) => {
    const aHasCreated = !!a.created_at
    const bHasCreated = !!b.created_at

    if (aHasCreated && !bHasCreated) return -1
    if (!aHasCreated && bHasCreated) return 1

    if (aHasCreated && bHasCreated) {
      return new Date(a.created_at) - new Date(b.created_at)
    }

    const aValue = a.value || ""
    const bValue = b.value || ""
    return aValue.localeCompare(bValue)
  })
}